import { Box, Checkbox, FormControlLabel } from '@mui/material';
import React from 'react';

export const TOGGLE = { ALL: 'all', INCOMPLETE: 'incomplete' } as const;
export type ToggleValue = typeof TOGGLE[keyof typeof TOGGLE];

export default function IncompleteFilter({
  onChange,
  incompleteQuesitonCount,
  showIncompleteOnly,
}: {
  onChange?: (value: 'all' | 'incomplete') => void;
  incompleteQuesitonCount: number;
  showIncompleteOnly: boolean;
}) {

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    onChange?.(checked ? 'incomplete' : 'all');
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-start', px: 2, pb: 1 }}>
      <FormControlLabel
        control={
          <Checkbox
            size="small"
            checked={showIncompleteOnly}
            onChange={handleChange}
          />
        }
        label={
          `Only show incomplete (${incompleteQuesitonCount || 0})`
        }
      />
    </Box>
  );
}
